const API_URL = process.env.REACT_APP_API_URL || "";
const SESSION_KEY = "portfolio_session_id";

function getSessionId() {
  let sessionId = localStorage.getItem(SESSION_KEY);
  if (!sessionId) {
    sessionId = `${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
    localStorage.setItem(SESSION_KEY, sessionId);
  }
  return sessionId;
}

export async function trackEvent(payload) {
  try {
    await fetch(`${API_URL}/api/analytics/event`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        sessionId: getSessionId(),
        referrer: document.referrer,
        ...payload
      })
    });
  } catch (error) {
    console.error("Analytics tracking failed:", error);
  }
}

export function extractElementLabel(element) {
  if (!element) return "";

  const dataTrack = element.getAttribute?.("data-track");
  if (dataTrack) return dataTrack;

  const ariaLabel = element.getAttribute?.("aria-label");
  if (ariaLabel) return ariaLabel;

  const title = element.getAttribute?.("title");
  if (title) return title;

  const text = (element.innerText || element.textContent || "").trim().replace(/\s+/g, " ");
  if (text) return text.slice(0, 120);

  const imgAlt = element.querySelector?.("img")?.getAttribute?.("alt") || element.getAttribute?.("alt");
  if (imgAlt) return imgAlt;

  const className = typeof element.className === "string" ? element.className : "";
  if (className.includes("dark-mode-toggle")) return "Toggle Dark Mode";
  if (className.includes("terminal__launcher")) return "Open CLI Terminal";
  if (className.includes("work_item")) return `Filter: ${text || "category"}`;
  if (className.includes("work__button")) return "Project Externe Link";

  const href = element.getAttribute?.("href") || "";
  if (href) return href;

  return element.tagName || "Click";
}

export function setupClickTracking() {
  const clickHandler = (event) => {
    const selector = "a, button, [data-track], [role='button'], .work_item, .cube__face, .terminal__launcher-btn, .dark-mode-toggle";
    const element = event.target?.closest?.(selector);
    if (!element) return;

    const label = extractElementLabel(element);
    const href = element.getAttribute?.("href") || "";
    const tag = element.tagName || "";

    trackEvent({
      eventType: "click",
      path: window.location.pathname,
      pageTitle: document.title,
      targetText: label,
      targetTag: tag,
      targetHref: href
    });
  };

  document.addEventListener("click", clickHandler);
  return () => document.removeEventListener("click", clickHandler);
}

export async function fetchAnalyticsSummary(period = "7d", sendToDiscord = false) {
  const query = new URLSearchParams({ period });
  if (sendToDiscord) query.append("sendToDiscord", "true");
  
  const res = await fetch(`${API_URL}/api/analytics/summary?${query.toString()}`);
  if (!res.ok) {
    throw new Error(`Fout bij ophalen analytics: ${res.status} ${res.statusText}`);
  }
  return await res.json();
}
